import React from 'react';
import {Photo} from '@mui/icons-material';
import {Box, Stack} from '@mui/material';
import {designSystemToken} from '@lightricks/react-design-system';
import {Voice} from '@contentlab/api/avatars';
import contentLabStore from '@contentlab/stores/contentLabStore';
import FileSelector from '@/components/file-selector';

function CustomAvatarEditor({
  selectedId = null,
  onSelectVoice,
  onSelectImage,
}: {
  selectedId?: string | null;
  onSelectVoice?: (voice: Voice) => void;
  onSelectImage?: (file: File) => void | Promise<void>;
}) {
  contentLabStore((state) => state.draftAiAvatarProject.avatarSpec);

  return (
    <Stack gap="16px">
      <Box
        sx={{
          border: `1px solid ${designSystemToken('semantic.border.secondary')}`,
          borderRadius: '8px',
          padding: '12px',
          backgroundColor: designSystemToken('semantic.bg.primary'),
        }}
      >
        <FileSelector
          testID="custom-avatar-image-selector"
          title="Upload avatar image"
          description="PNG/JPG/WEBP"
          onFilesSelected={async (files) => {
            if (files && files[0]) {
              await onSelectImage?.(files[0]);
            }
          }}
          PreviewIcon={<Photo />}
          multiple={false}
          acceptTypes={['images']}
        />
      </Box>
    </Stack>
  );
}

export default CustomAvatarEditor;
